import Box from "@mui/material/Box";
import PlanText from "../Texts/PlanText";
import { FONT_SIZE_BUTTON, FONT_WEIGHT_BUTTON } from "../../utils/constants";

const UsageCounter = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        backgroundColor: "background.paper",
      }}
    >
      <PlanText
        variant="body1"
        sxTypography={{
          fontSize: FONT_SIZE_BUTTON,
          fontWeight: FONT_WEIGHT_BUTTON,
        }}
      />
    </Box>
  );
};

export default UsageCounter;
